module.exports = __webpack_public_path__ + "img/17a003-11.2b2e9818.jpg";